import "./FilterByColumn.scss";

import { Dropdown } from "react-bootstrap";
import type { Column } from "react-table";
import { useLocalStorage } from "usehooks-ts";

import { useUser } from "../../../contexts/userContext";
interface FilterByColumnProps {
  columns: Column[] | null;
}

const FilterByColumn = ({ columns }: FilterByColumnProps) => {
  const { user } = useUser();

  const [hiddenColumns, setColumnsToLocalStorage] = useLocalStorage<
    Record<string, string[]>
  >("hiddenColumns", {});

  const handleColumnFilterChange = (val: string) => {
    const cur = hiddenColumns[user?.sub || ""];

    const queryVal = cur?.includes(val)
      ? [...cur].filter(column => column !== val)
      : [...(cur || []), val];

    setColumnsToLocalStorage({
      ...hiddenColumns,
      [user?.sub || ""]: queryVal,
    });
  };

  const columnsByCurrentUser = hiddenColumns[user?.sub || ""];

  return (
    <Dropdown className="d-inline dropdown-checkboxes" autoClose="outside">
      <Dropdown.Toggle
        id="dropdown-autoclose-outside"
        className="select-columns"
      >
        {`Columns (${
          columns ? columns.length - (columnsByCurrentUser?.length || 0) : 0
        }/${columns?.length})`}
      </Dropdown.Toggle>
      <div className="short-explanation w-100">Show or hide columns</div>

      <Dropdown.Menu className="w-100 dropdown-menu" renderOnMount={false}>
        {columns?.map(
          col =>
            col.accessor !== "request" && (
              <div className="react-select-checkbox" key={`${col.accessor}`}>
                <input
                  type="checkbox"
                  id={`column-${col.accessor}`}
                  checked={
                    !columnsByCurrentUser?.includes(`${col.accessor}`) || false
                  }
                  onChange={() => handleColumnFilterChange(`${col.accessor}`)}
                />
                <label
                  htmlFor={`column-${col.accessor}`}
                >{`${col.Header}`}</label>
              </div>
            ),
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export { FilterByColumn };
